<template>
  <div class="main">
    <div class="container">
      <img src="../../assets/login_title.png" class="topIcon" alt="" />
      <img src="../../assets/downnew/down_new_title.png" style="object-fit: contain; width: 90%; margin-top: 90px;" />
      <div v-if="isRegister" class="playlet_success_tip" style="display: block">
        恭喜你，注册成功
      </div>

      <div v-if="false" @click="andoridDownLoadUrl" class="breath" style="width:80%; margin-top: 12px;">
        <img src="../../assets/downnew/down_new_android_big.png" style="width:100%;object-fit: contain;" />
      </div>

      <div class="row" style="margin-top: 6px;">
        <div @click="andoridDownLoadUrl">
          <img src="../../assets/downnew/down_new_android.png" style="width:150px;object-fit: contain;" />
        </div>

        <div @click="iosDownload" style="margin-left: 12px;">
          <img src="../../assets/downnew/down_new_iphone.png" style=" width:150px; object-fit: contain;" />
        </div>


      </div>

      <img src="../../assets/downnew/down_new_desc.png" alt="" style="width: 90%; object-fit: contain;" />

    </div>

    <div v-if="showWxBrower" class="tip">
      <img src="../../assets/wx_tip2.png" alt="" class="tip2" />
      <div class="tip3">
        <div>1.请点击右上角</div>
        <div>2.选择【在默认浏览器打开】</div>
      </div>
      <img src="../../assets/wx_tip1.png" alt="" class="tip4" />
    </div>

    <div class="kf" @click="toWxkefu()">
      <img src="../../assets/downnew/kf_btn.png" alt="" class="kf_btn breath-small" />
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import request from '../../utils/request';
const wxkefu = "https://work.weixin.qq.com/ca/cawcdef07bfd35e65c";
const iosUrl = "https://apps.apple.com/app/%E6%98%93%E5%85%83%E5%89%AA%E8%BE%91/id6743380265";
export default {
  data() {
    return {
      isRegister: false,
      downLoadUrl: "",
      showWxBrower: false,
      ios: false,
      miniScheme: '',
      token: "",
      isIosPointed: false,
      isAndroidPointed: false
    };
  },
  mounted() {
    this.token = this.$route.query.token;
    this.isRegister = this.$route.query.isRegister;
    this.getVersion();
    // this.appSource();
    // this.getScheme();
    this.point('DownLoadShow', '下载页面展示')
  },
  methods: {
    getVersion() {
      this.$request.GET({
        url: "app/version",
        params: { version: "1.0.0" },
        success: (res) => {
          this.downLoadUrl = res.downloadUrl;
        },
      });
    },
    andoridDownLoadUrl() {

      if (this.isWeiXin()) {
        this.showWxBrower = true;
      } else {
        if (!this.isAndroidPointed) {
          this.isAndroidPointed = true;
          this.point('AndroidClick', 'Android下载按钮点击')
        }
        setTimeout(() => { location.href = this.downLoadUrl; }, 1000)
      }
    },
    iosDownload() {
      this.point('iosClick', 'ios下载按钮点击')
      Toast('敬请期待~')
      // if (this.isWeiXin()) {
      //   this.showWxBrower = true;
      // } else {
      //   if (!this.isIosPointed) {
      //     this.isIosPointed = true;
      //     this.point('iosClick', 'ios下载按钮点击')
      //   }
      //   setTimeout(() => { location.href = iosUrl; }, 1000)
      // }

    },

    isWeiXin() {
      var ua = window.navigator.userAgent.toLowerCase();
      // ua.indexOf('micromessenger')为真-微信端，如果为假，就是其他浏览器
      if (ua.indexOf("micromessenger") > -1) {
        return true; // 是微信端
      } else {
        return false;
      }
      // return true;
    },
    openMini() {
      window.location.href = this.miniScheme;
    },
    getScheme() {
      this.$request.GET({
        url: 'homepage/mini',
        success: (obj) => {
          this.miniScheme = obj.url
        }
      })
    },
    appSource() {
      const u = navigator.userAgent,
        app = navigator.appVersion;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isiOS) {
        this.ios = true;
      } else {
        this.ios = false;
      }
    },

    toWxkefu() {
      this.point("kfClick", "下载页客服点击")
      // window.location.href = wxkefu;
      window.open(wxkefu);
    },

    point(eventKey, eventName) {
      const ua = navigator.userAgent;
      const dto = {
        brand: ua,
        token: this.token,
        behaviorName: eventKey,
        behaviorVal: JSON.stringify({
          modType: eventName,
          actionBehavior: eventName
        })
      }

      request.POST({
        url: "/behavior/report",
        data: dto,
        success: (obj) => { },
        showLoading: false
      })
    }
  },
};
</script>

<style scoped>
img {
  pointer-events: none;
}

.main {
  width: 100%;
  position: relative;
}

.container {
  width: 100%;
  background-image: url('../../assets/downnew/down_new_bg.png');
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  font-size: 0.32rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
}

.kf {
  position: fixed;

  bottom: 0;
  width: 100%;
  max-width: 750px;
  height: 90px;
  background: url(../../assets/downnew/kf_bg.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.kf_btn {
  width: 120px;
  object-fit: contain;
  position: absolute;
  right: 6px;
  top: 0;
  bottom: 0;
  margin: auto;

}

.column {
  display: flex;
  flex-direction: column;
}

.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.topIcon {
  position: absolute;
  left: 10px;
  top: 10px;
  object-fit: contain;
  width: 100px;
}

.btm {
  background: url(../../assets/down_btm_pic.png);
  background-repeat: no-repeat;
  background-size: 100%;
  width: 100%;
  object-fit: contain;
}

.tip {
  position: absolute;
  width: 100%;
  top: 0;
  bottom: 0;
  overflow-y: hidden;
  background: black;
  opacity: 0.9;
}

.tip2 {
  position: absolute;
  right: 0;
}

.tip3 {
  position: absolute;
  left: 16px;
  top: 30px;
  font-size: 18px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 28px;
  text-align: left;
}

.tip4 {
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  margin: auto;
}

a {
  text-decoration: none;
  color: #141414;
}

input {
  background: none;
  outline: none;
  border: none;
}

input:focus {
  border: none;
}

.playlet_logo {
  width: 100px;
  object-fit: contain;

}

.playlet_success_tip {
  font-size: 24px;
  font-weight: bold;
  margin-top: 20px;
  color: white;
  display: none;
}

.playlet_success_blank {
  width: 100%;
  height: 4rem;
}

.playlet_success_btn {
  width: 6.54rem;
  height: 0.88rem;
  background-color: #141414;
  border-radius: 0.04rem;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.playlet_success_btn_icon {
  margin-right: 0.16rem;
}

.playlet_success_btn_icon.iphone {
  width: 0.26rem;
  height: 0.32rem;
}

.playlet_success_btn_icon.android {
  width: 0.4rem;
  height: 0.22rem;
}

.playlet_success_tips {
  margin: 0.16rem 0 0.48rem;
}

.playlet_extra_wrap {
  display: none;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.85);
}

.playlet_extra {
  width: 100%;
  height: 100%;
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url(http://img2.hzhstb.com/d42e645d9d65025ccee323d3032dfce4_1926x1125.png);
}

/* 定义呼吸动画的关键帧 */
@keyframes breathing {

  0%,
  100% {
    transform: scale(1);
  }

  /* 元素在动画开始和结束时恢复原大小 */
  50% {
    transform: scale(1.1);
  }

  /* 在动画中间点放大10% */
}

@keyframes breathing-small {

  0%,
  100% {
    transform: scale(1);
  }

  /* 元素在动画开始和结束时恢复原大小 */
  50% {
    transform: scale(1.05);
  }

  /* 在动画中间点放大10% */
}

/* 应用呼吸动画到一个元素上 */
.breath {
  animation-name: breathing;
  /* 引用定义好的关键帧动画 */
  animation-duration: 1s;
  /* 动画持续时间 */
  animation-iteration-count: infinite;
  /* 动画无限循环 */
  animation-timing-function: ease-in-out;
  /* 动画速度曲线 */
}

.breath-small {
  animation-name: breathing-small;
  /* 引用定义好的关键帧动画 */
  animation-duration: 1s;
  /* 动画持续时间 */
  animation-iteration-count: infinite;
  /* 动画无限循环 */
  animation-timing-function: ease-in-out;
  /* 动画速度曲线 */
}

.serviceBox {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>